import { months } from "../../../../../Utils/months";

export const calcularTotalesPorCategoria = (categoriaData) => {
  const resultado = {};

  for (let i = 0; i < months.length; i++) {
    const mes = months[i];

    resultado[mes] = {
      ejecutado: 0,
      presupuestado: 0,
      variacion: 0,
    };

    if (Array.isArray(categoriaData)) {
      for (let j = 0; j < categoriaData.length; j++) {
        const fila = categoriaData[j];
        const mesData = fila && fila[mes] ? fila[mes] : {};

        resultado[mes].presupuestado += parseFloat(mesData.presupuestado || 0);
        resultado[mes].ejecutado += parseFloat(mesData.ejecutado || 0);
        resultado[mes].variacion += parseFloat(mesData.variacion || 0);
      }
    }
  }

  return resultado;
};

export const calcularTotalesConSigno = (categoriaData, getSign) => {
  const resultado = {};

  for (let i = 0; i < months.length; i++) {
    const mes = months[i];
    resultado[mes] = {
      ejecutado: 0,
      presupuestado: 0,
      variacion: 0,
    };
  }

  if (Array.isArray(categoriaData)) {
    for (let j = 0; j < categoriaData.length; j++) {
      const fila = categoriaData[j];
      const signo = getSign(fila);

      for (let i = 0; i < months.length; i++) {
        const mes = months[i];
        const mesData = fila && fila[mes] ? fila[mes] : {};

        resultado[mes].presupuestado += signo * parseFloat(mesData.presupuestado || 0);
        resultado[mes].ejecutado += signo * parseFloat(mesData.ejecutado || 0);
        resultado[mes].variacion += signo * parseFloat(mesData.variacion || 0);
      }
    }
  }

  return resultado;
};
